import { render, staticRenderFns } from "./mainData.vue?vue&type=template&id=85cd4064"
import script from "./mainData.vue?vue&type=script&lang=js"
export * from "./mainData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports